import { render, staticRenderFns } from "./footer-info.vue?vue&type=template&id=50c24701&scoped=true"
import script from "./footer-info.vue?vue&type=script&lang=js"
export * from "./footer-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c24701",
  null
  
)

export default component.exports